export { useConfig } from "../../providers/useConfig";
//# sourceMappingURL=index.js.map